import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  RateCard,
  RateCardResponse,
  Route,
  Vendor,
  VehicleSize,
} from '../models/rate-card.model';
import { ApiEndpoints } from './api-endpoints';

@Injectable({
  providedIn: 'root',
})
export class RateCardService {
  private baseUrl = environment.baseUrl;
  private rateCardUrl = `${environment.baseUrl}${ApiEndpoints.RATE_CARD}`;

  constructor(private http: HttpClient) {}

  getRateCards(
    pageNumber: number = 1,
    pageSize: number = 10,
    searchText: string = ''
  ): Observable<RateCardResponse> {

    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    if (searchText) {
      params = params.set('search', searchText);
    }

    return this.http.get<RateCardResponse>(
      this.rateCardUrl,
      // `http://localhost:3029/billing/rate-card`,
      { params }
    );
  }

  createRateCard(rateCard: RateCard): Observable<RateCard> {

    return this.http.post<RateCard>(
      this.rateCardUrl,
      rateCard,
    );
  }

  updateRateCard(
    id: string,
    rateCard: Partial<RateCard>,
  ): Observable<RateCard> {

    return this.http.put<RateCard>(
      `${this.rateCardUrl}/${id}`,
      rateCard,
    );
  }

  deleteRateCard(id: string): Observable<void> {

    return this.http.delete<void>(
      `${this.rateCardUrl}/${id}`,
    );
  }

  getRateCardById(id: string): Observable<RateCard> {
    return this.http.get<RateCard>(
      `${this.rateCardUrl}/${id}`
    );
  }

  getRoutes(): Observable<Route[]> {

    return this.http.get<Route[]>(
      `${this.baseUrl}/routemaster/vehicle-routes`
    );
  }

  getVendors(): Observable<Vendor[]> {

    return this.http.get<Vendor[]>(
      `${this.baseUrl}/tms-onboarding/vendor/list`
    );
  }

  getVehicleSizes(): VehicleSize[] {
    return [
      { value: '8FT', label: '8 FT' },
      { value: '10FT', label: '10 FT' },
      { value: '12FT', label: '12 FT' },
      { value: '14FT', label: '14 FT' },
      { value: '17FT', label: '17 FT' },
      { value: '19FT', label: '19 FT' },
      { value: '20FT', label: '20 FT' },
      { value: '22FT', label: '22 FT' },
      { value: '24FT', label: '24 FT' },
      { value: '28FT', label: '28 FT' },
      { value: '32FT', label: '32 FT' },
      { value: 'BOLERO', label: 'BOLERO' },
      { value: 'TATA ACE', label: 'TATA ACE' },
    ];
  }

  getRateTypes(): { value: string; label: string }[] {
    return [
      { value: 'TOTAL', label: 'Per Trip' },
      { value: 'KM', label: 'Per Kilometer' },
      { value: 'DAILY', label: 'Fixed Daily' },
      { value: 'WEEKLY', label: 'Fixed Weekly' },
      { value: 'MONTHLY', label: 'Fixed Monthly' },
      { value: 'YEARLY', label: 'Fixed Yearly' },
    ];
  }
}
